import React from "react";
import { useNavigate } from "react-router-dom";
import { Gauge, Calendar, Fuel, Cog, Car } from "lucide-react";
import { fileUrl } from "../lib/api";

const fmtPrice = (n) => new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
const fmtKm = (n) => new Intl.NumberFormat("pt-PT").format(n) + " km";

export const NoPhoto = ({ className = "" }) => (
  <div className={`flex flex-col items-center justify-center bg-gradient-to-br from-secondary via-muted to-accent/40 ${className}`}>
    <Car className="w-12 h-12 text-primary/40" />
    <span className="text-xs font-semibold text-muted-foreground/70 mt-2 tracking-wide">Sem fotografia</span>
  </div>
);

export const VehicleCard = ({ vehicle, index = 0 }) => {
  const navigate = useNavigate();
  const hasImg = vehicle.images && vehicle.images.length > 0;
  const hasPromo = vehicle.promo_price != null && vehicle.promo_price > 0 && vehicle.promo_price < vehicle.price;

  return (
    <article
      data-testid="vehicle-card"
      onClick={() => navigate(`/viatura/${vehicle.id}`)}
      className="group cursor-pointer bg-white rounded-3xl overflow-hidden border border-black/5 hover:shadow-2xl hover:shadow-black/10 transition-shadow duration-300 animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        {hasImg ? (
          <img src={fileUrl(vehicle.images[0])} alt={`${vehicle.brand} ${vehicle.model}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <NoPhoto className="w-full h-full" />
        )}
        {vehicle.sold && (
          <span className="absolute top-4 left-4 bg-zinc-900 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide">Vendido</span>
        )}
        {hasPromo && !vehicle.sold && (
          <span data-testid="promo-tag" className="absolute top-4 left-4 bg-red-600 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide shadow-lg">Promoção</span>
        )}
        {vehicle.sold ? (
          <div className="absolute bottom-4 right-4 bg-zinc-900 text-white px-4 py-2 rounded-full shadow-lg font-heading font-bold text-sm uppercase tracking-wide">Vendido</div>
        ) : (
          <div className="absolute bottom-4 right-4 bg-primary text-primary-foreground px-4 py-2 rounded-full shadow-lg">
            {hasPromo ? (
              <div className="flex flex-col items-end leading-none gap-0.5">
                <span className="text-[11px] font-semibold line-through opacity-75">{fmtPrice(vehicle.price)}</span>
                <span className="font-heading font-bold text-lg">{fmtPrice(vehicle.promo_price)}</span>
              </div>
            ) : (
              <span className="font-heading font-bold text-lg">{fmtPrice(vehicle.price)}</span>
            )}
          </div>
        )}
      </div>
      <div className="p-6">
        <h3 className="font-heading font-bold text-xl tracking-tight">{vehicle.brand} {vehicle.model}</h3>
        <div className="grid grid-cols-2 gap-3 mt-5 text-sm text-muted-foreground">
          <span className="flex items-center gap-2"><Calendar className="w-4 h-4 text-primary" /> {vehicle.month ? `${String(vehicle.month).padStart(2, "0")}/${vehicle.year}` : vehicle.year}</span>
          <span className="flex items-center gap-2"><Gauge className="w-4 h-4 text-primary" /> {fmtKm(vehicle.mileage)}</span>
          <span className="flex items-center gap-2"><Fuel className="w-4 h-4 text-primary" /> {vehicle.fuel}</span>
          <span className="flex items-center gap-2"><Cog className="w-4 h-4 text-primary" /> {vehicle.gearbox}</span>
        </div>
      </div>
    </article>
  );
};

export { fmtPrice, fmtKm };
